import { render, staticRenderFns } from "./templateConfig.vue?vue&type=template&id=7d84f615&scoped=true"
import script from "./templateConfig.vue?vue&type=script&lang=js"
export * from "./templateConfig.vue?vue&type=script&lang=js"
import style0 from "./templateConfig.vue?vue&type=style&index=0&id=7d84f615&prod&lang=css"
import style1 from "./templateConfig.vue?vue&type=style&index=1&id=7d84f615&prod&scoped=true&lang=css"
import style2 from "./templateConfig.vue?vue&type=style&index=2&id=7d84f615&prod&lang=css"
import style3 from "./templateConfig.vue?vue&type=style&index=3&id=7d84f615&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d84f615",
  null
  
)

export default component.exports